export const DEFAULT_CURRENCY_SYMBOL = '€';
export const DEFAULT_CURRENCY_CODE = 'EUR';
export const DEFAULT_CURRENCY_ID = '5b4e1194264c036e4192a932'; // EUR
